<template>
  <section id="client-information-form-extensions-section">
    <v-card-title class="font-weight-medium primary--text">
      Configuración de Extensiones
    </v-card-title>
    <extension-row
      v-for="(row, idx) in extensionsArr"
      :row="row"
      :key="row.id"
      :showAdd="idx === 0"
      :showDelete="idx !== 0"
      :onAdd="handleAddRow"
      :onDelete="handleDeleteRow"
      @data:change="(data) => handleChangeRowFields(row.id, data)"
    ></extension-row>
  </section>
</template>

<script>
import ExtensionRow from "./ExtensionRow.vue";
export default {
  props: {
    extensionsArr: {
      type: Array,
    },
  },

  components: {
    ExtensionRow,
  },

  methods: {
    autogenerateId() {
      return Math.floor(1000 + Math.random() * 9000);
    },

    /**
     * Dispatch the change event with the new Array
     *
     * @param  {Array} updated array
     *
     */
    changePayload(newArr) {
      this.$emit("extension:change", newArr);
    },

    /**
     * Update the row with the given data
     *
     * @param rowId {Number} id of the row to be updated
     * @param newData {Object} updated data
     * @param newData.field {string} name of the field to be updated
     * @param newData.value {string} new value
     *
     */
    handleChangeRowFields(rowId, { field, value }) {
      const newArr = this.extensionsArr.map((el) => (el.id === rowId ? { ...el, [field]: value } : el));
      this.changePayload(newArr);
    },

    /**
     * Create a new row with an autogenerated ID
     */
    handleAddRow() {
      const newArr = [...this.extensionsArr, { id: this.autogenerateId(), name: "", extension: "", group: "" }];
      this.changePayload(newArr);
    },

    /**
     * Remove the row of the given id
     */
    handleDeleteRow(id) {
      const newArr = this.extensionsArr.filter((el) => el.id !== id);
      this.changePayload(newArr);
    },
  },
};
</script>

<style></style>
